import { LAB_SAMPLE_STATUSES, SAMPLE_REPORT_STATUSES } from './constants';

export const MONITORING_BLOCKS = {
  acceptance: 'acceptance',
  expired: 'expired',
  closing: 'closing',
  awaitingProcessing: 'awaitingProcessing',
};

export const MONITORING_PERMISSIONS = {
  [MONITORING_BLOCKS.acceptance]: ['dashboardMonitoringAcceptanceView'],
  [MONITORING_BLOCKS.expired]: ['dashboardMonitoringView'],
  [MONITORING_BLOCKS.closing]: ['dashboardMonitoringView'],
  [MONITORING_BLOCKS.awaitingProcessing]: ['dashboardMonitoringView'],
};

export const EXPORT_BLOCK_PARAM = {
  [MONITORING_BLOCKS.acceptance]: 'pending-acceptance',
  [MONITORING_BLOCKS.expired]: 'expired',
  [MONITORING_BLOCKS.closing]: 'closing-due',
  [MONITORING_BLOCKS.awaitingProcessing]: 'awaiting-processing',
};

export const ACCEPTANCE_BUCKET_PARAM = {
  twoDays: 'd2',
  threeToFiveDays: 'd3to5',
  moreThanFiveDays: 'gt5',
};

export const DELIVERY_DATE_FIELD = 'expectedDeliveryDate';
export const ACCEPTANCE_DATE_FIELD = 'orderSentAt';
export const LABORATORY_FIELD = 'laboratory';
export const LOCATION_FIELD = 'locationId';
export const SAMPLE_REPORT_STATUS_FIELD = 'sampleReportStatus';

// ---------------------------------------------------------------------------
// Block definitions (drive the generic block renderers)
// ---------------------------------------------------------------------------

export const ACCEPTANCE_DEF = {
  blockKey: MONITORING_BLOCKS.acceptance,
  titleKey: 'monitoringDashboard.blocks.acceptance.title',
  rows: null,
  columns: [
    {
      key: 'twoDays',
      dataKey: 'd2',
      labelKey: 'monitoringDashboard.blocks.acceptance.buckets.twoDays',
    },
    {
      key: 'threeToFiveDays',
      dataKey: 'd3to5',
      labelKey: 'monitoringDashboard.blocks.acceptance.buckets.threeToFiveDays',
    },
    {
      key: 'moreThanFiveDays',
      dataKey: 'gt5',
      labelKey:
        'monitoringDashboard.blocks.acceptance.buckets.moreThanFiveDays',
    },
  ],
};

// Block 3 — matrix, rows = status, columns = day bucket. Cell key = `${row}_${col}`.
export const CLOSING_DEF = {
  blockKey: MONITORING_BLOCKS.closing,
  titleKey: 'monitoringDashboard.blocks.closing.title',
  rows: [
    { key: 'tbv', labelKey: 'monitoringDashboard.stati.tbv' },
    { key: 'tba', labelKey: 'monitoringDashboard.stati.tba' },
    { key: 'tbs', labelKey: 'monitoringDashboard.stati.tbs' },
  ],
  columns: [
    {
      key: 'today',
      dataKey: 'today',
      labelKey: 'monitoringDashboard.blocks.closing.buckets.today',
    },
    {
      key: 'tomorrow',
      dataKey: 'tom',
      labelKey: 'monitoringDashboard.blocks.closing.buckets.tomorrow',
    },
    {
      key: 'dayAfterTomorrow',
      dataKey: 'dat',
      labelKey: 'monitoringDashboard.blocks.closing.buckets.dayAfterTomorrow',
    },
  ],
};

export const EXPIRED_DEF = {
  blockKey: MONITORING_BLOCKS.expired,
  titleKey: 'monitoringDashboard.blocks.expired.title',
  cards: [
    {
      key: 'accepted',
      dataKey: 'accepted',
      labelKey: 'monitoringDashboard.stati.accepted',
      icon: 'el-icon-circle-check',
    },
    {
      key: 'inprogress',
      dataKey: 'inProgress',
      labelKey: 'monitoringDashboard.stati.inprogress',
      icon: 'el-icon-edit',
    },
    {
      key: 'tobeverified',
      dataKey: 'toBeVerified',
      labelKey: 'monitoringDashboard.stati.tobeverified',
      icon: 'el-icon-view',
    },
    {
      key: 'tobeapproved',
      dataKey: 'toBeApproved',
      labelKey: 'monitoringDashboard.stati.tobeapproved',
      icon: 'el-icon-finished',
    },
    {
      key: 'completedunsigned',
      dataKey: 'completedUnsigned',
      labelKey: 'monitoringDashboard.stati.completedunsigned',
      icon: 'el-icon-edit-outline',
    },
  ],
};

export const ACCEPTANCE_CARDS = {
  blockKey: MONITORING_BLOCKS.acceptance,
  titleKey: 'monitoringDashboard.blocks.acceptance.title',
  cards: [
    {
      key: 'd2',
      labelKey: 'monitoringDashboard.blocks.acceptance.buckets.twoDays',
      icon: 'el-icon-time',
      drillStatusKey: null,
      drillBucketKey: 'twoDays',
      severity: 'info',
    },
    {
      key: 'd3to5',
      labelKey: 'monitoringDashboard.blocks.acceptance.buckets.threeToFiveDays',
      icon: 'el-icon-warning-outline',
      drillStatusKey: null,
      drillBucketKey: 'threeToFiveDays',
      severity: 'warning',
    },
    {
      key: 'gt5',
      labelKey:
        'monitoringDashboard.blocks.acceptance.buckets.moreThanFiveDays',
      icon: 'el-icon-warning',
      drillStatusKey: null,
      drillBucketKey: 'moreThanFiveDays',
      severity: 'critical',
    },
  ],
};

export const CLOSING_CARDS = {
  blockKey: MONITORING_BLOCKS.closing,
  titleKey: 'monitoringDashboard.blocks.closing.title',
  cards: [
    {
      key: 'tbv_today',
      label: 'Da verificare – Oggi',
      icon: 'el-icon-view',
      drillStatusKey: 'tbv',
      drillBucketKey: 'today',
    },
    {
      key: 'tbv_tom',
      label: 'Da verificare – Domani',
      icon: 'el-icon-view',
      drillStatusKey: 'tbv',
      drillBucketKey: 'tomorrow',
    },
    {
      key: 'tbv_dat',
      label: 'Da verificare – Dopodomani',
      icon: 'el-icon-view',
      drillStatusKey: 'tbv',
      drillBucketKey: 'dayAfterTomorrow',
    },
    {
      key: 'tba_today',
      label: 'Da approvare – Oggi',
      icon: 'el-icon-finished',
      drillStatusKey: 'tba',
      drillBucketKey: 'today',
    },
    {
      key: 'tba_tom',
      label: 'Da approvare – Domani',
      icon: 'el-icon-finished',
      drillStatusKey: 'tba',
      drillBucketKey: 'tomorrow',
    },
    {
      key: 'tba_dat',
      label: 'Da approvare – Dopodomani',
      icon: 'el-icon-finished',
      drillStatusKey: 'tba',
      drillBucketKey: 'dayAfterTomorrow',
    },
    {
      key: 'tbs_today',
      label: 'Da firmare – Oggi',
      icon: 'el-icon-edit-outline',
      drillStatusKey: 'tbs',
      drillBucketKey: 'today',
    },
    {
      key: 'tbs_tom',
      label: 'Da firmare – Domani',
      icon: 'el-icon-edit-outline',
      drillStatusKey: 'tbs',
      drillBucketKey: 'tomorrow',
    },
    {
      key: 'tbs_dat',
      label: 'Da firmare – Dopodomani',
      icon: 'el-icon-edit-outline',
      drillStatusKey: 'tbs',
      drillBucketKey: 'dayAfterTomorrow',
    },
  ],
};

export const AWAITING_PROCESSING_COLUMNS = [
  {
    key: 'oneDay',
    dataKey: 'd1',
    labelKey: 'monitoringDashboard.blocks.toBeProcessed.buckets.oneDay',
  },
  {
    key: 'twoToThreeDays',
    dataKey: 'd2to3',
    labelKey: 'monitoringDashboard.blocks.toBeProcessed.buckets.twoToThreeDays',
  },
  {
    key: 'fourToFiveDays',
    dataKey: 'd4to5',
    labelKey: 'monitoringDashboard.blocks.toBeProcessed.buckets.fourToFiveDays',
  },
  {
    key: 'sixToTenDays',
    dataKey: 'd6to10',
    labelKey: 'monitoringDashboard.blocks.toBeProcessed.buckets.sixToTenDays',
  },
  {
    key: 'moreThanTenDays',
    dataKey: 'gt10',
    labelKey:
      'monitoringDashboard.blocks.toBeProcessed.buckets.moreThanTenDays',
  },
];

export const AWAITING_PROCESSING_KPIS = [
  {
    key: 'totalAccepted',
    dataKey: 'totalAccepted',
    labelKey: 'monitoringDashboard.blocks.toBeProcessed.kpis.totalAccepted',
    icon: 'el-icon-files',
    severity: 'safe',
  },
  {
    key: 'backlogOver10',
    dataKey: 'backlogOver10',
    labelKey: 'monitoringDashboard.blocks.toBeProcessed.kpis.backlogOver10',
    icon: 'el-icon-warning',
    severity: 'critical',
  },
  {
    key: 'departmentsInvolved',
    dataKey: 'departmentsInvolved',
    labelKey:
      'monitoringDashboard.blocks.toBeProcessed.kpis.departmentsInvolved',
    icon: 'el-icon-office-building',
    severity: 'safe',
  },
];

// ---------------------------------------------------------------------------
// Status maps (cell/card key -> LAB_SAMPLE_STATUSES enum)                   |
// ---------------------------------------------------------------------------
export const EXPIRED_STATUS_ENUM = {
  accepted: LAB_SAMPLE_STATUSES.ACCEPTED,
  inprogress: LAB_SAMPLE_STATUSES.INPROGRESS,
  tobeverified: LAB_SAMPLE_STATUSES.TOBEVERIFIED,
  tobeapproved: LAB_SAMPLE_STATUSES.TOBEAPPROVED,
  completedunsigned: LAB_SAMPLE_STATUSES.COMPLETED,
};

export const CLOSING_STATUS_ENUM = {
  tbv: LAB_SAMPLE_STATUSES.TOBEVERIFIED,
  tba: LAB_SAMPLE_STATUSES.TOBEAPPROVED,
  tbs: LAB_SAMPLE_STATUSES.COMPLETED,
};

// ---------------------------------------------------------------------------
// Date helpers + bucket -> loopback where builders
// ---------------------------------------------------------------------------
function startOfDay(dayOffset = 0) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + dayOffset);
  return d.toISOString();
}

const CLOSING_BUCKET_OFFSET = {
  today: 0,
  tomorrow: 1,
  dayAfterTomorrow: 2,
};

function acceptanceBucketWhere(bucketKey) {
  switch (bucketKey) {
    case 'twoDays':
      return {
        [ACCEPTANCE_DATE_FIELD]: { between: [startOfDay(-2), startOfDay(-1)] },
      };
    case 'threeToFiveDays':
      return {
        [ACCEPTANCE_DATE_FIELD]: { between: [startOfDay(-5), startOfDay(-2)] },
      };
    case 'moreThanFiveDays':
      return { [ACCEPTANCE_DATE_FIELD]: { lt: startOfDay(-5) } };
    default:
      return {};
  }
}

function closingBucketRange(bucketKey) {
  const offset = CLOSING_BUCKET_OFFSET[bucketKey];
  return { between: [startOfDay(offset), startOfDay(offset + 1)] };
}

/**
 * Build the GET /samples `where` clause for a Blocks 1–3 drill-down.
 * Mirrors the BE count bucketing so the detail list equals the card count.
 */
export function buildDetailWhere(drill, filters = {}) {
  const where = {};

  if (filters.locationIds && filters.locationIds.length) {
    where[LOCATION_FIELD] = { inq: filters.locationIds };
  }

  if (
    drill.blockKey !== MONITORING_BLOCKS.acceptance &&
    filters.laboratories &&
    filters.laboratories.length
  ) {
    where[LABORATORY_FIELD] = { inq: filters.laboratories };
  }

  if (drill.blockKey === MONITORING_BLOCKS.acceptance) {
    where.status = LAB_SAMPLE_STATUSES.PENDING;
    Object.assign(where, acceptanceBucketWhere(drill.bucketKey));
  } else if (drill.blockKey === MONITORING_BLOCKS.expired) {
    where.status = EXPIRED_STATUS_ENUM[drill.statusKey];
    where[DELIVERY_DATE_FIELD] = { lt: startOfDay(0) };
    if (drill.statusKey === 'completedunsigned') {
      where[SAMPLE_REPORT_STATUS_FIELD] = {
        inq: [
          SAMPLE_REPORT_STATUSES.TOBEAPPROVED,
          SAMPLE_REPORT_STATUSES.DOCUMENTPENDING,
        ],
      };
    }
  } else if (drill.blockKey === MONITORING_BLOCKS.closing) {
    where.status = CLOSING_STATUS_ENUM[drill.statusKey];
    where[DELIVERY_DATE_FIELD] = closingBucketRange(drill.bucketKey);
    if (drill.statusKey === 'tbs') {
      where[SAMPLE_REPORT_STATUS_FIELD] = {
        inq: [
          SAMPLE_REPORT_STATUSES.TOBEAPPROVED,
          SAMPLE_REPORT_STATUSES.DOCUMENTPENDING,
        ],
      };
    }
  }

  return where;
}

export function buildMonitoringParams(filters = {}, includeReparto = true) {
  const params = {};
  if (filters.locationIds && filters.locationIds.length) {
    params.locationIds = filters.locationIds;
  }
  if (includeReparto && filters.laboratories && filters.laboratories.length) {
    params.laboratories = filters.laboratories;
  }
  return params;
}

const CLOSING_ROW_MAP = {
  toBeVerified: 'tbv',
  toBeApproved: 'tba',
  toBeSigned: 'tbs',
};

const CLOSING_COL_MAP = {
  today: 'today',
  tomorrow: 'tom',
  dayAfterTomorrow: 'dat',
};

// The normalize* helpers are an anti-corruption layer.
// they remap the API field names (toBeVerified, inProgress…)
// onto the stable internal keys the block renderers
export function normalizeClosingData(apiData) {
  const colEntries = Object.entries(CLOSING_COL_MAP);
  return Object.fromEntries(
    Object.entries(CLOSING_ROW_MAP).flatMap(([apiRow, rowKey]) => {
      const rowObj = apiData[apiRow];
      if (!rowObj) return [];
      return colEntries.map(([apiCol, colKey]) => [
        `${rowKey}_${colKey}`,
        rowObj[apiCol] || 0,
      ]);
    })
  );
}

// EXPIRED_DEF reads BE fields directly via
// each card's `dataKey`, so the payload is passed through untouched. The matrix
// (closing) still needs normalizeClosingData because it reshapes nested → flat.
export function normalizeAwaitingRows(apiData = {}) {
  const rows = (apiData.rows || [])
    .map((r) => ({
      ...r,
      familyCode: r.familyCode ?? r.familycode,
      familyDescription: r.familyDescription ?? r.familydescription,
    }))
    .sort(
      (a, b) =>
        String(a.laboratory || '').localeCompare(String(b.laboratory || '')) ||
        String(a.familyDescription || '').localeCompare(
          String(b.familyDescription || '')
        )
    );

  return { rows, kpis: apiData.kpis || {} };
}
